import { render, staticRenderFns } from "./DetalheClientesSemFaturamento.vue?vue&type=template&id=1ae9af6b&scoped=true&"
import script from "./DetalheClientesSemFaturamento.vue?vue&type=script&lang=js&"
export * from "./DetalheClientesSemFaturamento.vue?vue&type=script&lang=js&"
import style0 from "./DetalheClientesSemFaturamento.vue?vue&type=style&index=0&id=1ae9af6b&scoped=true&lang=css&"
import style1 from "./DetalheClientesSemFaturamento.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae9af6b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VCol,VContainer,VDatePicker,VDivider,VIcon,VMenu,VRow,VSelect,VTextField,VTooltip})
